const initialState = {
    
    text : '',
    author : '',
    categories : []
    
};
export default initialState;
